
<template>
  <div>
    <!-- Dialog box of credit card deatils -->
    <v-dialog v-model="dialog" width="400" scrollable persistent @keydown.esc="closeDialog()">
      <v-card>
        <!-- Card title -->
        <v-card-title>
          <span class="text-h5">Add Card</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeDialog()">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="custom-dialog">
          <v-container>
            <v-row>
              <v-col cols="12" class="mt-3">
                <span style="font-size: small" v-if="option.plan">
                  <strong>Your plan</strong>
                  Per User {{ option.plan }} ({{
                    option.product.includes("_")
                      ? option.product.replace(/_/g, " ")
                      : option.product
                  }}) (${{ option.amount }})
                </span>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  v-model="cardDetail.name"
                  label="Name on Card"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="mt-n8">
                <v-text-field
                  outlined
                  dense
                  v-model="cardDetail.phone"
                  label="Phone Number"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-n8">
                <v-text-field
                  outlined
                  dense
                  v-model="cardDetail.address"
                  label="Address"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                class="mt-n8"
                v-if="
                  !getSelectedCompany.subscribed_plan ||
                  (getSelectedCompany.subscribed_plan &&
                    (getSelectedCompany.subscribed_plan.toLowerCase() == 'basic' || getSelectedCompany.subscribed_plan.toLowerCase() == 'unlimited_plan'))
                "
              >
                <v-text-field
                  outlined
                  dense
                  v-model="cardDetail.teamMemberQuantity"
                  label="Team Members Quantity"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-n8">
                <v-select
                  outlined
                  dense
                  v-model="cardDetail.country"
                  :items="countries"
                  item-text="text"
                  item-value="value"
                  label="Select Country"
                  required
                ></v-select>
              </v-col>
              <div class="w-100 px-3" id="card-element"></div>
              <div></div>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Button for add card -->
          <v-btn
            :loading="loader"
            color="#1cc283"
            dark
            class="text-capitalize"
            @click="submit()"
          >
            add card
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Importing snackbar -->
    <div>
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />
    </div>
  </div>
</template>

<script>
import PaymentMethodMixin from "@/components/Payment/PaymentMethodMixin";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";

export default {
  data() {
    //Public keys for stripe
    this.publishableKey = process.env.VUE_APP_STRIPE_KEY;
    return {
      option: {
        plan: null,
        product: null,
        amount: 0,
      },
    };
  },
  mixins: [PaymentMethodMixin, snackbarMixin],
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  computed: {
    ...mapGetters(["getSelectedCompany"]),
  },
  mounted() {
    // Open Add Card Dialog while adding a new card
    eventBus.$on("openCreditCardModal", (data) => {
      this.dialog = data;
      this.paymentIntent();
      setTimeout(this.mountStripeElement(), 5000);
    });
    // Called when subscribed the plan for the first time
    eventBus.$on("selectedPlan", (data) => {
      this.dialog = true;
      this.paymentIntent();
      this.option.plan = data.plan === "yearly" ? "Yearly" : "Monthly";
      this.option.product = data.product.replace(/^\w/, (c) => c.toUpperCase());
      this.option.amount = data.amount;
      this.cardDetail.stripe_plan = data.plan;
      this.cardDetail.stripe_product = data.product;
      let that = this;
      setTimeout(that.mountStripeElement(), 3000);
    });
    this.cardElement.addEventListener("change", ({ error }) => {
      if (error) {
        this.openSnackbar(true, error.message);
      }
    });
  },
  methods: {
    // Function to mount cardElement in DOM
    mountStripeElement() {
      this.$nextTick(function () {
        this.cardElement.mount("#card-element");
      });
    },
  },
};
</script>

<style></style>
